module.exports = __webpack_public_path__ + "static/img/csi3.d13db136.png";